// (c) Santosh Sahoo

import { useId } from "vue";

export interface FormProp {
  name: string;
  label: string;
  class?: string;
  placeholder?: string;
  required?: boolean;
  readonly?: boolean;
  type?: "bool" | "textarea" | string;
  options?: unknown[];
  validation?: unknown[];
}

export const basicFormProps = {
  name: { default: "inp" },
  uid: {
    default: () => useId(),
  },
  modelValue: { required: true },
  error: String,
  label: String,
  classname: { type: String, default: "form-control" },
  help: String,
  placeholder: String,
  required: Boolean,
  disabled: Boolean,
};
